import { Types, Actions } from './actions';
import {
  VERIFY_SUCCESS_HTTP_STATUS,
  VERIFY_FAILURE_HTTP_STATUS,
  VERIFY_TIMEOUT_ERROR_MESSAGE,
} from './constants';
import authApi from '~/api';
import { TIMEOUT_ERROR } from '~/api/constants';
import { LOGIN_SUCCESS } from '~/components/analytics/constants';
import identify from '~/components/analytics/identify';
import track from '~/components/analytics/track';

const middleware = (store: any) => (next: any) => (action: any) => {
  const { dispatch } = store;
  const { payload } = action;
  if (action.type === Types.VERIFY_SUCCESS) {
    dispatch(Actions.SET_USER(payload));
    dispatch(Actions.SET_TOKEN(payload.accessToken));
    identify(payload.user);
  }
  if (action.type === Types.VERIFY_REQUEST) {
    authApi
      .get('/auth/verify') // todo: this path does not belong here
      .then((res: any) => {
        const { status, data } = res;
        if (status === VERIFY_SUCCESS_HTTP_STATUS) {
          dispatch(Actions.VERIFY_SUCCESS(data));
          track(LOGIN_SUCCESS);
        } else if (status === VERIFY_FAILURE_HTTP_STATUS) {
          dispatch(Actions.VERIFY_FAILURE());
        } else if (!res.ok && res.problem === TIMEOUT_ERROR) {
          dispatch(
            Actions.VERIFY_ERROR({
              error: new Error(VERIFY_TIMEOUT_ERROR_MESSAGE),
            }),
          );
        } else {
          dispatch(Actions.VERIFY_ERROR({ error: res.originalError }));
        }
      })
      .catch(err => {
        dispatch(Actions.VERIFY_ERROR({ error: err }));
      });
  }
  next(action);
};

export default middleware;
